import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "../components/Logo";
import { Input } from "../components/ui/input";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/home";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) navigate(user.role === "admin" ? "/admin" : "/home", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back, " + u.name);
      navigate(u.role === "admin" ? "/admin" : (location.state?.from || "/home"), { replace: true });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy flex flex-col">
      <div className="p-5"><Link to="/"><Logo light /></Link></div>
      <div className="flex-1 flex items-center justify-center px-4 pb-10">
        <div className="w-full max-w-md bg-white rounded-3xl p-7 shadow-lift animate-scale-in">
          <h1 className="font-heading font-extrabold text-2xl text-navy">Masuk ke BAWAIN</h1>
          <p className="text-sm text-muted-foreground mt-1">Mau dari sana? Bawain.</p>

          <button onClick={googleLogin} data-testid="google-login-btn"
            className="mt-5 w-full rounded-full border border-black/10 py-3 font-semibold text-navy flex items-center justify-center gap-2 hover:bg-cloud transition-colors">
            <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4" /> Lanjut dengan Google
          </button>

          <div className="flex items-center gap-3 my-5">
            <div className="h-px bg-black/10 flex-1" /><span className="text-xs text-muted-foreground">atau</span><div className="h-px bg-black/10 flex-1" />
          </div>

          <form onSubmit={submit} className="space-y-3">
            <Input data-testid="login-email" type="email" placeholder="Email" value={email}
              onChange={(e) => setEmail(e.target.value)} className="rounded-xl h-11" required />
            <Input data-testid="login-password" type="password" placeholder="Password" value={password}
              onChange={(e) => setPassword(e.target.value)} className="rounded-xl h-11" required />
            <button type="submit" disabled={busy} data-testid="login-submit"
              className="w-full rounded-full bg-lime hover:bg-lime-dark text-navy font-bold py-3 transition-colors disabled:opacity-60">
              {busy ? "..." : "Masuk"}
            </button>
          </form>

          <p className="text-sm text-center mt-5 text-muted-foreground">
            Belum punya akun?{" "}
            <Link to="/register" data-testid="go-register" className="font-bold text-navy underline">Daftar</Link>
          </p>
          <div className="mt-4 text-xs text-center text-muted-foreground bg-cloud rounded-xl p-2">
            Demo: titiper@bawain.demo / bawainer1@bawain.demo · password123
          </div>
        </div>
      </div>
    </div>
  );
}
